import { useEffect, useRef } from 'react';
/**
 * Dismiss a popover when the pointer goes down anywhere outside `ref`.
 * Inert while `active` is false, so a closed popover costs nothing.
 */
export function useOutsideClick(ref, active, onOutside) {
    const callback = useRef(onOutside);
    callback.current = onOutside;
    useEffect(() => {
        if (!active)
            return;
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target))
                callback.current();
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [ref, active]);
}
export default useOutsideClick;
